import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from "vue-lazyload";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 高德地图key
// bd4ddaae971e0dc682929dff0765ea8d
Vue.use(VueLazyload);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// title
// const defaultTitle = '默认 title'
// router.beforeEach((to, from, next) => {
//   document.title = to.meta.title ? to.meta.title : defaultTitle
//   next()
// })